module.exports = __webpack_public_path__ + "img/to-table-icon.230a83b3.svg";